import { api } from "../../utils/api";

export const postAccount = async (data, bank) => {
  try {
    const response = await api.post(`homologation/${bank}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}